export const hash = {
  withSHA256: async (message: string): Promise<string> => {
    if (!window.crypto?.subtle) {
      return '';
    }
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => `00${b.toString(16)}`.slice(-2)).join('');
  },
};
